import { Button, Col, Form, Row, Space, theme, Table, message, Popconfirm, Select } from 'antd';
import React, { useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddSalary from './component/ModalAddSalary';
import { salaries_list, salaries_delete, salaries_detail, salaries_lock_update } from '../../services/apis';
import { FORMAT_DATE, HeaderTableCus, LIST_MONTH, LIST_YEAR, requiredItem, TYPE_MODAL } from '../../constants/constants';
import { filterOption, formatNumber, isAdmin } from '../../utils/funcHelper';
import { useSelector } from 'react-redux';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { LockOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const ListSalaryPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const [is_locked, setIs_Locked] = useState(false);
    const userReducer = useSelector(state => state?.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Mã kỳ lương',
            dataIndex: 'batch_code',
            key: 'batch_code',
            width: 120,
            align: 'center',
            render: (text, record, index) => <a onClick={() => handleEditSalary(record)} style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</a>,
        },
        {
            title: 'Kỳ lương',
            dataIndex: 'salary_month',
            key: 'salary_month',
            width: 150,
            align: 'center',
            render: (text, record, index) => <a onClick={() => handleEditSalary(record)} style={{ paddingLeft: 12, paddingRight: 12 }}>Tháng {dayjs(text).format(FORMAT_DATE.MMYYYY)}</a>,
        },
        {
            title: 'Tổng số nhân viên',
            dataIndex: 'total_employees',
            key: 'total_employees',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Tổng lương',
            dataIndex: 'total_income',
            key: 'total_income',
            align: 'center',
            width: 200,
            render: (text, record, index) => <div><strong>{formatNumber(text, 2)}</strong></div>,
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
            align: 'center',
            render: (text, record, index) => <div style={{ textAlign: 'left', paddingLeft: 12, paddingRight: 12 }}>{text}</div>,
        },
        {
            title: 'Người tạo',
            dataIndex: 'created_by_name',
            key: 'created_by_name',
            align: 'center',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'center',
            render: (text, record, index) => <div >{text}</div>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 150,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditSalary(record)} >{record?.is_locked ? 'Xem' : 'Sửa'}</a>

                    {
                        isAdmin(userReducer) && !record?.is_locked ?
                            <Popconfirm
                                title="Bạn có chắc chắn muốn khoá bảng lương?"
                                onConfirm={() => handleLock(record)}
                                okText="Có"
                                cancelText="Không"
                            >   
                                <LockOutlined />
                                <a style={{ color: 'red' }}>Khoá</a>
                            </Popconfirm> : null
                    }

                    {
                        isAdmin(userReducer) ?
                            <Popconfirm
                                title="Bạn có chắc chắn muốn xoá?"
                                onConfirm={() => handleDelete(record)}
                                okText="Có"
                                cancelText="Không"
                            >
                                <a style={{ color: 'red' }}>Xoá</a>
                            </Popconfirm> : null
                    }


                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleEditSalary = async (record) => {

        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await salaries_detail(params);
            setLoading(false);
            consoleLogUtil("res salaries_detail", res)
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setTypeModal(TYPE_MODAL.EDIT);
                setShowModal(true);
                setIs_Locked(record?.is_locked);
                setTitleModal('Thông tin bảng lương');
            } else {
                setIs_Locked(record?.is_locked);
                setItemSelected(null);
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            setLoading(false);
        }
    }
    const handleAddSalary = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm bảng lương mới');
    }
    const handleDelete = (record) => {

        if (!isAdmin(userReducer)) {
            message.error('Bạn không có quyền xoá bảng lương');
            return;
        }

        const payload = {
            id: record?.id,
            updated_by: userReducer?.user_info?.id,
        }
        callAPIDeleteSalary(payload);
    }

    const handleLock = async (record) => {
        if (!isAdmin(userReducer)) {
            message.error('Bạn không có quyền khoá bảng lương');
            return;
        }
        try {
            const payload = {
                batch_id: record?.id,
                is_locked: 1,
                updated_by: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await salaries_lock_update(payload);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Khoá bảng lương thành công');
                getDataSalaries();
            } else {
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            setLoading(false);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
        }
    }

    const getDataSalaries = async () => {
        try {
            const params = {
                month: form.getFieldValue('month') || '',
                year: form.getFieldValue('year') || '',
            }
            setLoading(true);
            const res = await salaries_list(params);
            consoleLogUtil("res salaries_list", res)
            setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data]);
                setTotalRecords(res?.data?.length ?? 0);
            } else {
                message.error(res.message);
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            setLoading(false);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataSalaries();
    };


    const callAPIDeleteSalary = async (data) => {
        try {
            setLoading(true);
            const res = await salaries_delete(data);
            setLoading(false);
            if (res && res.status === 1) {
                getDataSalaries();
            } else {
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            setLoading(false);
        }
    }


    const handleOnSave = async (data) => {

    }

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'month'}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn tháng lương'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={LIST_MONTH}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="year"
                            rules={requiredItem}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn năm'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={LIST_YEAR}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Tìm kiếm
                            </Button>
                            <Button danger onClick={handleAddSalary} icon={<PlusOutlined />}>
                                Tạo bảng lương
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataSalaries(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} nhân viên`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataSalaries(1, true, size);
                    }
                }}
            />
            <LoadingBase loading={loading} />
            <ModalAddSalary
                visible={showModal}
                onCancel={() => setShowModal(false)}
                dataItem={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
                is_locked={is_locked}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListSalaryPage);